export default "__VITE_ASSET__CMICkWG$__"